import {
  FormInput,
  FormSearchAddress,
  FormSelect,
  IconButton,
} from "@ac-expo/ui-components";
import { Control, FieldValues, Path, useFormContext } from "react-hook-form";
import { AddEventAsVisitorForm, usePlacesQuery } from "@ac-expo/api";
import EventCustomMapModal from "../Map/EventCustomMapModal";
import { useGoogleApiContext } from "@web-app/src/context/googleApi.context";

function PlacesList() {
  const { control, setValue, watch } = useFormContext<AddEventAsVisitorForm>();
  const { isLoaded } = useGoogleApiContext();

  const restoreTextAddress = () => {
    setValue("place.address.address", "");
    setValue("place.address.lat", null);
    setValue("place.address.long", null);
  };

  const { lat, long, address } = watch("place.address");
  const isCoordsAddress = lat && long && !address;

  return (
    <div>
      <div className="flex flex-col gap-2">
        <FormInput
          control={control}
          name="place.name"
          label="Lieu de l'événement"
          placeholder="Parc des Expositions"
          errorRing
        />
        <div className="flex items-end gap-2">
          {!isCoordsAddress && (
            <FormSearchAddress
              className="grow"
              control={control}
              name="place.address"
              label="Adresse"
              placeholder="5 rue en Chatoux, 21490 RUFFEY LES ECHIREY"
              isMapApiLoaded={isLoaded}
            />
          )}
          <EventCustomMapModal />
          {isCoordsAddress && (
            <div className="flex w-full justify-between text-xs text-gray-500">
              <div>
                <p>{lat}</p>
                <p>{long}</p>
              </div>
              <IconButton
                svgType="arrowUUpLeft"
                svgProps={{ size: 24, className: "text-blue-500" }}
                className="px-1"
                type="button"
                variant={"outline-blue"}
                onClick={restoreTextAddress}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PlacesList;

export function SearchPlaceForm<TForm extends FieldValues>({
  control,
  name,
}: {
  control: Control<TForm>;
  name: Path<TForm>;
}) {
  const { data: places, isLoading, isError } = usePlacesQuery();

  if (isLoading) return <>Loading</>;
  if (isError || !places || !places.map)
    return (
      <div className="h-full md:p-5">
        <p>Erreur</p>
      </div>
    );

  return (
    <FormSelect
      control={control}
      label="Lieu"
      placeholder="Rechercher un lieu"
      name={name}
      items={places.map((place) => ({
        value: place.id,
        label: place.name,
      }))}
    />
  );
}
